import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import LinkCollection from './components/LinkCollection';
import Lagerplatzverzeichnis from './components/Lagerplatzverzeichnis';
import LagerAdmin from './components/LagerAdmin';
import Wiki from './components/Wiki';
import NavBar from './components/NavBar';
import Login from './components/Login';
import AnAbmeldungen from './components/AnAbmeldungen';
import ChastlizettelPublic from './components/ChastlizettelPublic';
import CalendarPage from './components/CalendarPage';
import { auth } from './firebase/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Spinner, Container } from 'react-bootstrap';

const ConditionalNavBar = ({ user }) => {
  const location = useLocation();
  if (location.pathname.startsWith('/chastlizettel')) {
    return null;
  }
  return <NavBar />;
};

const App = () => {
  const [user, loading] = useAuthState(auth);
  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }
  const currentUser = user
    ? {
        name: user.displayName || 'Benutzer',
        email: user.email,
        uid: user.uid,
      }
    : null;

  return (
    <Router>
      {user && <ConditionalNavBar user={user} />}
      <Routes>
        <Route path="/chastlizettel/:group" element={<ChastlizettelPublic />} />
        {user ? (
          <>
            <Route path="/dashboard" element={<Dashboard user={currentUser} />} />
            <Route path="/links" element={<LinkCollection />} />
            <Route path="/lagerplatzverzeichnis" element={<Lagerplatzverzeichnis />} />
            <Route path="/lager-admin" element={<LagerAdmin />} />
            <Route path="/wiki" element={<Wiki user={currentUser} />} />
            <Route path="/anabmeldungen" element={<AnAbmeldungen />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;